import React from "react";
import $ from "jquery";
import "./Study.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Spinner from "../Spinner/Spinner";
import { withRouter } from "react-router";
import { withAuth } from "../../app/util/HOC";
import { PieChart } from "react-minimal-pie-chart";
import StudyCenterHeader from "./StudyCenterHeader";
import { handleException } from "../../app/util/util";
import ProgressBar from "react-bootstrap/ProgressBar";
import loaderColors1 from "../Spinner/loaderColors1.gif";
const chapters = [
  "Property Fall 2020",
  "Iron Dwarf",
  "Highborn Human",
  "Lowland Human",
  "Mountain Dwarf",
  "Scythian Elf",
  "Woodland Elf",
];
export class StudyCenterProfessorPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loLength: 0,
      progress: 50,
      bookISBN: "",
      haveText: "",
      bookTitle: "",
      loading: false,
      viewTopic: false,
      classVOList: null,
      currentClassId: 0,
      chapterNavTitle: "",
      studyDashBoardVO: null,
      backtoStudyCenter: false,
      serviceCompletion: false,
      numberOfEnrolledStudent: 1,
      learningObjectiveProgressVOList: null,
      bookVO: JSON.parse(localStorage.getItem("bookVO")),
      userVO: JSON.parse(localStorage.getItem("userVO")),
      keepMeLogIn: localStorage.getItem("keepLoggedIn") ? "true" : "false",
    };
    this.navigateToAssessment = this.navigateToAssessment.bind(this);
    this.reviewQuestion = this.reviewQuestion.bind(this);
    this.handleText = this.handleText.bind(this);
  }
  componentDidMount = () => {
    this.getClassDetails();
  };
  componentWillUnmount() {}
  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.props.match.params.chapterid !== prevProps.match.params.chapterid
    ) {
      this.getClassDetails();
    }
    document.title = `${this.state.bookVO !== null ? this.state.bookVO.bookTitle : ""} | ${this.state.chapterNavTitle ? this.state.chapterNavTitle : ""} | Study Center | Aspen Publishing`;
  };
  getClassDetails() {
    let reqData = {
      userVO: {
        userId: this.state.userVO.userId,
        userActivityVO: {
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "StudyCenter",
          pageNavigatingTo: "StudyCenterQuestion",
        },
        sessionVO: {
          appType: "web",
          deviceMacId: "",
          deviceOS: localStorage.getItem("deviceOS"),
          keepMeLoggedInFlag: this.state.keepMeLogIn,
          deviceType: localStorage.getItem("deviceType"),
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken:
            this.state.userVO.sessionAuthenticationToken,
        },
        userRole: this.state.userVO.userRole,
        userRoleId: this.state.userVO.userRoleId,
      },
      bookVO: { bookISBN: this.props.match.params.isbn },
    };
    const requestOptions1 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(reqData),
    };
    this.setState({ loading: true });
    fetch(
      localStorage.getItem("ENV") + "/manageClassWebService/getAllClassByIsbn",
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          if (data.status === "true") {
            var bookVO = data.bookVO,
              classVOList = data.classVOList;
            let reqData = {
              userVO: {
                userId: this.state.userVO.userId,
                userActivityVO: {
                  lastActivityCode: "BOOKSHELF",
                  pageNavigatingFrom: "BOOKSHELF",
                  pageNavigatingTo: "BOOKSHELF",
                  lastViewedLearningObjectId: "",
                },
                sessionVO: {
                  appType: "web",
                  deviceMacId: "",
                  deviceOS: localStorage.getItem("deviceOS"),
                  keepMeLoggedInFlag: this.state.keepMeLogIn,
                  deviceType: localStorage.getItem("deviceType"),
                  browserName: localStorage.getItem("browserName"),
                  sessionAuthenticationToken:
                    this.state.userVO.sessionAuthenticationToken,
                },
                userRole: this.state.userVO.userRole,
                userRoleId: this.state.userVO.userRoleId,
              },
              bookVO: {
                bookISBN: this.props.match.params.isbn,
              },
              chapterVO: {
                chapterId: this.props.match.params.chapterid,
              },
            };
            var selectedClassId, selectedClassName;
            if (this.state.userVO.userRoleId === "5") {
              selectedClassId = "-999";
              reqData.classVO = { classId: "-999" };
            } else {
              this.setState({
                currentClassId: this.props.history.location.hash.replace(
                  "#",
                  "",
                ),
              });
              var classId = this.state.currentClassId;
              if (classId) {
                if (classVOList)
                  classVOList = Array.isArray(classVOList)
                    ? classVOList
                    : [classVOList];
                reqData.classVO = { classId: classId };
                selectedClassId = classId;
                for (var i = 0; i < classVOList.length; i++) {
                  if (classVOList[i].classId === classId) {
                    selectedClassName = classVOList[i].className;
                    break;
                  }
                }
              } else {
                if (classVOList) {
                  classVOList = Array.isArray(classVOList)
                    ? classVOList
                    : [classVOList];
                  reqData.classVO = { classId: classVOList[0].classId };
                  selectedClassId = classVOList[0].classId;
                  selectedClassName = classVOList[0].className;
                }
              }
            }
            const requestOptions1 = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(reqData),
            };
            fetch(
              localStorage.getItem("ENV") +
                "/manageClassWebService/getStudyCenterViewForProfOrStudentRv",
              requestOptions1,
            )
              .then((response) => response.json())
              .then((data) => {
                if (data) {
                  if (data.status === "true") {
                    var numberOfEnrolledStudent = 0;
                    if (data.numberOfEnrolledStudent)
                      numberOfEnrolledStudent = parseInt(
                        data.numberOfEnrolledStudent,
                      );
                    if (data.chapterLearningObjectiveVO) {
                      var chapterLearningObjectiveVO =
                        data.chapterLearningObjectiveVO;
                      if (
                        chapterLearningObjectiveVO !== null &&
                        chapterLearningObjectiveVO.learningObjectiveProgressVOList
                      ) {
                        var learningObjectiveProgressVOList =
                          chapterLearningObjectiveVO.learningObjectiveProgressVOList;
                        learningObjectiveProgressVOList = Array.isArray(
                          learningObjectiveProgressVOList,
                        )
                          ? learningObjectiveProgressVOList
                          : [learningObjectiveProgressVOList];
                        localStorage.setItem(
                          "sumOfAllQuestions",
                          chapterLearningObjectiveVO.sumOfAllQuestions,
                        );
                        if (
                          this.state.userVO.userRole === "Professor" &&
                          numberOfEnrolledStudent === 0
                        ) {
                          learningObjectiveProgressVOList.forEach(
                            (lopVolist) => {
                              var loExplainerResp = Array.isArray(
                                lopVolist.learningObjectiveExplainerResponseList,
                              )
                                ? lopVolist.learningObjectiveExplainerResponseList
                                : [
                                    lopVolist.learningObjectiveExplainerResponseList,
                                  ];
                              loExplainerResp.forEach((loer) => {
                                loer.totalCorrectAnswer = "0";
                                loer.totalPartialCorrect = "0";
                                loer.totalUnAnswered = loer.totalQuestions;
                                loer.totalWrongAnswer = "0";
                              });
                              var loRespList = Array.isArray(
                                lopVolist.learningObjectiveResponseList,
                              )
                                ? lopVolist.learningObjectiveResponseList
                                : [lopVolist.learningObjectiveResponseList];
                              loRespList.forEach((lor) => {
                                lor.totalCorrectAnswer = "0";
                                lor.totalPartialCorrect = "0";
                                lor.totalUnAnswered = lor.totalQuestions;
                                lor.totalWrongAnswer = "0";
                              });
                              lopVolist.totalCorrectAnswerInLearningObjective =
                                "0";
                              lopVolist.totalPartialCorrectInLearningObjective =
                                "0";
                              lopVolist.totalUnAnsweredInLearningObjective =
                                lopVolist.totalNumberOfQuestionInLearningObjective;
                              lopVolist.totalWrongAnswerInLearningObjective =
                                "0";
                            },
                          );
                        }
                        var currBook = {
                          bookISBN: data.chapterVO.bookISBN,
                          bookTitle:
                            data.chapterVO !== undefined
                              ? data.chapterVO.bookTitle
                              : "",
                          chapterId:
                            data.chapterVO !== undefined
                              ? data.chapterVO.chapterId
                              : "",
                        };
                        this.setState({
                          learningObjectiveProgressVOList:
                            learningObjectiveProgressVOList,
                          loading: false,
                          loLength: learningObjectiveProgressVOList.length,
                          serviceCompletion: true,
                          chapterNavTitle:
                            data.chapterVO !== undefined
                              ? data.chapterVO.navbarTitle
                              : "",
                          bookISBN:
                            data.chapterVO !== undefined
                              ? data.chapterVO.bookISBN
                              : "",
                          bookTitle:
                            data.chapterVO !== undefined
                              ? data.chapterVO.bookTitle
                              : "",
                          bookVO: bookVO,
                          classVOList: classVOList,
                          haveText: selectedClassName
                            ? selectedClassName
                            : null,
                          currentClassId: selectedClassId ? selectedClassId : 0,
                          numberOfEnrolledStudent: numberOfEnrolledStudent,
                        });
                      } else {
                        var currBook = {
                          bookISBN: data.chapterVO.bookISBN,
                          bookTitle:
                            data.chapterVO !== undefined
                              ? data.chapterVO.bookTitle
                              : "",
                          chapterId:
                            data.chapterVO !== undefined
                              ? data.chapterVO.chapterId
                              : "",
                        };
                        this.setState({
                          learningObjectiveProgressVOList: null,
                          loading: false,
                          serviceCompletion: true,
                          bookTitle:
                            data.chapterVO !== undefined
                              ? data.chapterVO.bookTitle
                              : "",
                          bookVO: bookVO,
                          classVOList: classVOList,
                          haveText: selectedClassName
                            ? selectedClassName
                            : null,
                          currentClassId: selectedClassId ? selectedClassId : 0,
                          numberOfEnrolledStudent: numberOfEnrolledStudent,
                        });
                      }
                      this.collapseAll1();
                    }
                  } else if (data.wkErrorCode) {
                    handleException(data);
                  }
                }
              })
              .catch((error) => {
                console.error(
                  "There has been a problem with your fetch operation:",
                  error,
                );
                this.setState({ loading: false, serviceCompletion: true });
              });
          } else if (data.wkErrorCode) {
            handleException(data);
          }
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
        this.setState({ loading: false });
      });
  }
  handleText = (ev) => {
    var classId =
      ev.currentTarget.getAttribute("classId") !== undefined ||
      ev.currentTarget.getAttribute("classId") !== "-999"
        ? ev.currentTarget.getAttribute("classId")
        : 0;
    var className = ev.currentTarget.textContent;
    if (classId) {
      let reqData2 = {
        userVO: {
          userId: this.state.userVO.userId,
          userActivityVO: {
            lastActivityCode: "BOOKSHELF",
            pageNavigatingFrom: "BOOKSHELF",
            pageNavigatingTo: "BOOKSHELF",
          },
          sessionVO: {
            appType: "web",
            browserName: localStorage.getItem("browserName"),
            deviceMacId: "",
            deviceOS: localStorage.getItem("deviceOS"),
            deviceType: localStorage.getItem("deviceType"),
            keepMeLoggedInFlag: this.state.keepMeLogIn,
            sessionAuthenticationToken:
              this.state.userVO.sessionAuthenticationToken,
          },
          userRole: this.state.userVO.userRole,
          userRoleId: this.state.userVO.userRoleId,
        },
        bookVO: {
          bookId: this.state.bookVO.bookId,
          classId: classId,
          bookISBN: this.props.match.params.isbn,
        },
        chapterVO: {
          chapterId: this.props.match.params.chapterid,
        },
        classVO: {
          classId: classId,
        },
      };
      const requestOptions2 = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(reqData2),
      };
      fetch(
        localStorage.getItem("ENV") +
          "/manageClassWebService/getStudyCenterViewForProfOrStudentRv",
        requestOptions2,
      )
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            if (data.status === "true") {
              var numberOfEnrolledStudent = 0;
              if (data.numberOfEnrolledStudent)
                numberOfEnrolledStudent = parseInt(
                  data.numberOfEnrolledStudent,
                );
              if (data.chapterLearningObjectiveVO) {
                var chapterLearningObjectiveVO =
                  data.chapterLearningObjectiveVO;
                if (
                  chapterLearningObjectiveVO !== null &&
                  chapterLearningObjectiveVO.learningObjectiveProgressVOList
                ) {
                  var learningObjectiveProgressVOList = Array.isArray(
                    chapterLearningObjectiveVO.learningObjectiveProgressVOList,
                  )
                    ? chapterLearningObjectiveVO.learningObjectiveProgressVOList
                    : [
                        chapterLearningObjectiveVO.learningObjectiveProgressVOList,
                      ];
                  localStorage.setItem(
                    "sumOfAllQuestions",
                    chapterLearningObjectiveVO.sumOfAllQuestions,
                  );
                  if (
                    this.state.userVO.userRole === "Professor" &&
                    numberOfEnrolledStudent === 0
                  ) {
                    learningObjectiveProgressVOList.forEach((lopVolist) => {
                      var loExplainerResp = Array.isArray(
                        lopVolist.learningObjectiveExplainerResponseList,
                      )
                        ? lopVolist.learningObjectiveExplainerResponseList
                        : [lopVolist.learningObjectiveExplainerResponseList];
                      loExplainerResp.forEach((loer) => {
                        loer.totalCorrectAnswer = "0";
                        loer.totalPartialCorrect = "0";
                        loer.totalUnAnswered = loer.totalQuestions;
                        loer.totalWrongAnswer = "0";
                      });
                      var loRespList = Array.isArray(
                        lopVolist.learningObjectiveResponseList,
                      )
                        ? lopVolist.learningObjectiveResponseList
                        : [lopVolist.learningObjectiveResponseList];
                      loRespList.forEach((lor) => {
                        lor.totalCorrectAnswer = "0";
                        lor.totalPartialCorrect = "0";
                        lor.totalUnAnswered = lor.totalQuestions;
                        lor.totalWrongAnswer = "0";
                      });
                      lopVolist.totalCorrectAnswerInLearningObjective = "0";
                      lopVolist.totalPartialCorrectInLearningObjective = "0";
                      lopVolist.totalUnAnsweredInLearningObjective =
                        lopVolist.totalNumberOfQuestionInLearningObjective;
                      lopVolist.totalWrongAnswerInLearningObjective = "0";
                    });
                  }
                  this.setState({
                    learningObjectiveProgressVOList:
                      learningObjectiveProgressVOList,
                    chapterNavTitle:
                      data.chapterVO !== undefined
                        ? data.chapterVO.navbarTitle
                        : "",
                    haveText: className,
                    currentClassId:
                      classId !== undefined || classId == null ? classId : 0,
                  });
                } else {
                  this.setState({
                    learningObjectiveProgressVOList: null,
                    haveText: className,
                    currentClassId:
                      classId !== undefined || classId == null ? classId : 0,
                  });
                }
              }
            } else {
              if (data.wkErrorCode) {
                handleException(data);
              }
            }
          }
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
          this.setState({ loading: false });
        });
    }
  };
  collapseAll1() {
    let i = 0;
    for (i = 0; i < this.state.loLength; i++) {
      if (
        document.getElementById("secondMenuITag" + i).className !== undefined
      ) {
        document.getElementById("secondMenuITag" + i).className = "fa fa-plus";
        document.getElementById("secondMenuDiv" + i).classList.add("hiddenDiv");
        document
          .getElementById("hiddenExpand" + i)
          .classList.remove("display-none");
      }
    }
  }
  expandClickEvent = (event) => {
    if (event.target.className == "fa fa-plus") {
      event.target.className = "fa fa-minus";
      if (
        document.getElementById(
          "secondMenuDiv" + event.target.getAttribute("index"),
        ).classList !== undefined
      ) {
        document
          .getElementById("secondMenuDiv" + event.target.getAttribute("index"))
          .classList.remove("hiddenDiv");
        document
          .getElementById("hiddenExpand" + event.target.getAttribute("index"))
          .classList.add("display-none");
        $(`#secondMenuITag${event.target.getAttribute("index")}`).attr(
          "aria-label",
          "Collapse Topic",
        );
        $(`#secondMenuITag${event.target.getAttribute("index")}`).attr(
          "aria-pressed",
          "true",
        );
      }
    } else {
      event.target.className = "fa fa-plus";
      if (
        document.getElementById(
          "secondMenuDiv" + event.target.getAttribute("index"),
        ).classList !== undefined
      ) {
        document
          .getElementById("secondMenuDiv" + event.target.getAttribute("index"))
          .classList.add("hiddenDiv");
        document
          .getElementById("hiddenExpand" + event.target.getAttribute("index"))
          .classList.remove("display-none");
        $(`#secondMenuITag${event.target.getAttribute("index")}`).attr(
          "aria-label",
          "Expand Topic",
        );
        $(`#secondMenuITag${event.target.getAttribute("index")}`).attr(
          "aria-pressed",
          "false",
        );
      }
    }
  };
  expandClickOnNameEvent = (event) => {
    var plus = document.getElementById(
      "secondMenuITag" + event.target.getAttribute("index"),
    );
    if (plus.getAttribute("index") == event.target.getAttribute("index")) {
      if (plus.className == "fa fa-plus") {
        plus.className = "fa fa-minus";
        document
          .getElementById("secondMenuDiv" + event.target.getAttribute("index"))
          .classList.remove("hiddenDiv");
        document
          .getElementById("hiddenExpand" + event.target.getAttribute("index"))
          .classList.add("display-none");
      } else {
        plus.className = "fa fa-plus";
        document
          .getElementById("secondMenuDiv" + event.target.getAttribute("index"))
          .classList.add("hiddenDiv");
        document
          .getElementById("hiddenExpand" + event.target.getAttribute("index"))
          .classList.remove("display-none");
      }
    }
  };
  navigateToDashBoard = (e) => {
    this.props.history.push(`/study/${this.props.match.params.isbn}`);
  };
  navigateToAssessment = (e) => {
    var revQuestTyp = e.currentTarget.getAttribute("questionType");
    const questType =
      revQuestTyp === "multichoice"
        ? "/mcq/"
        : revQuestTyp === "flashcard"
          ? "/flashcard/"
          : revQuestTyp === "hypothetical"
            ? "/shortanswer/"
            : revQuestTyp === "essay"
              ? "/essay/"
              : revQuestTyp === "issuespotting"
                ? "/issuespotting/"
                : null;
    if (questType)
      this.props.history.push(
        `/study/${this.props.match.params.isbn}/${this.props.match.params.chapterid + questType + e.currentTarget.getAttribute("learningObjectiveId")}`,
      );
  };
  reviewQuestion = (e) => {
    var classId = this.state.currentClassId;
    var revQuestTyp = e.currentTarget.getAttribute("questionType");
    if (classId === undefined || classId === null) classId = 0;
    const questType =
      revQuestTyp === "multichoice"
        ? "/mcqreview/"
        : revQuestTyp === "flashcard"
          ? "/flashcardreview/"
          : revQuestTyp === "hypothetical"
            ? "/shortanswerreview/"
            : revQuestTyp === "essay"
              ? "/essayreview/"
              : revQuestTyp === "issuespotting"
                ? "/issuespottingreview/"
                : null;
    if (questType)
      this.props.history.push(
        `/study/${this.props.match.params.isbn}/${this.props.match.params.chapterid + questType + e.currentTarget.getAttribute("learningObjectiveId")}#${classId}`,
      );
  };
  openWatchVideoPage = (e) => {
    const vidTyp = e.currentTarget.getAttribute("explainertype");
    const expType =
      vidTyp === "video"
        ? "/watchvideo/"
        : vidTyp === "text"
          ? "/readexplanation/"
          : null;
    if (expType)
      this.props.history.push(
        `/study/${this.props.match.params.isbn}/${this.props.match.params.chapterid + expType + e.currentTarget.getAttribute("learningObjectiveId")}`,
      );
  };
  handleBackToStudyCenter = (e) => {
    if (e.key === "Enter") {
      this.navigateToDashBoard();
    }
  };
  handleExpandStudyHeading = (e) => {
    if (e.key === "Enter") {
      this.expandClickOnNameEvent(e);
    }
  };
  handlePracticeQuestion = (e) => {
    if (e.key === "Enter") {
      this.reviewQuestion(e);
    }
  };
  handleWatchVideoPage = (e) => {
    if (e.key === "Enter") {
      this.openWatchVideoPage(e);
    }
  };
  handleViewResultDropdown = (e) => {
    if (e.key === "Enter") {
      this.handleClick();
    }
  };
  render() {
    let studyPieChart = (practice, LoId) => {
      var studyData = [];
      var totalStudents = this.state.numberOfEnrolledStudent
        ? this.state.numberOfEnrolledStudent > 0
          ? this.state.numberOfEnrolledStudent
          : 1
        : 1;
      var totalQuestions = practice.totalQuestions;
      var overallQuestion = totalQuestions * totalStudents;
      studyData.push({
        title: "correct",
        value: parseInt((practice.totalCorrectAnswer / overallQuestion) * 100),
        color: "#85BC20",
      });
      studyData.push({
        title: "incorrect ",
        value: parseInt((practice.totalWrongAnswer / overallQuestion) * 100),
        color: "#E5202E",
      });
      studyData.push({
        title: "needs practice",
        value: parseInt((practice.totalPartialCorrect / overallQuestion) * 100),
        color: "#7FBCE1",
      });
      studyData.push({
        title: "unanswered",
        value: parseInt((practice.totalUnAnswered / overallQuestion) * 100),
        color: "#ECECEC",
      });
      return (
        <PieChart
          startAngle={270}
          lengthAngle={360}
          lineWidth={35}
          key={LoId + "_" + practice.questionType}
          id={LoId + "_" + practice.questionType}
          data={studyData}
        />
      );
    };
    let chartStats = (practice) => {
      var totalStudents = this.state.numberOfEnrolledStudent
        ? this.state.numberOfEnrolledStudent > 0
          ? this.state.numberOfEnrolledStudent
          : 1
        : 1;
      var totalQuestions = practice.totalQuestions;
      var overallQuestion = totalQuestions * totalStudents;
      var correctPercentage =
        (practice.totalCorrectAnswer / overallQuestion) * 100;
      var incorrectPercentage =
        (practice.totalWrongAnswer / overallQuestion) * 100;
      var needPracticePercentage =
        (practice.totalPartialCorrect / overallQuestion) * 100;
      var totalUnAnsweredPercentage =
        (practice.totalUnAnswered / overallQuestion) * 100;
      correctPercentage = parseFloat(
        correctPercentage % 1 === 0
          ? Math.round(correctPercentage)
          : correctPercentage.toFixed(2),
      );
      incorrectPercentage = parseFloat(
        incorrectPercentage % 1 === 0
          ? Math.round(incorrectPercentage)
          : incorrectPercentage.toFixed(2),
      );
      needPracticePercentage = parseFloat(
        needPracticePercentage % 1 === 0
          ? Math.round(needPracticePercentage)
          : needPracticePercentage.toFixed(2),
      );
      var unanswered = parseFloat(
        totalUnAnsweredPercentage % 1 === 0
          ? Math.round(totalUnAnsweredPercentage)
          : totalUnAnsweredPercentage.toFixed(2),
      );
      return (
        <span>
          {correctPercentage}% correct <br />
          {incorrectPercentage}% incorrect <br />
          {needPracticePercentage}% needs practice <br />
          {unanswered}% unanswered
        </span>
      );
    };
    let itemList = (props) => {
      var schoolList = this.state.classVOList;
      if (schoolList) {
        const list = schoolList.map((item) => (
          <div
            onClick={this.handleText}
            className="dropdown__item"
            classId={item.classId}
            key={item.classId}
            classCode={item.classCode}
          >
            {item.className}
          </div>
        ));
        return <div className="dropdown__items"> {list} </div>;
      }
    };
    let decimalFormat = (value) => {
      if (!isNaN(value))
        return parseFloat(
          value % 1 === 0 ? Math.round(value) : value.toFixed(2),
        );
    };
    return (
      <React.Fragment>
        {!this.state.backtoStudyCenter ? (
          <div>
            <Spinner
              loading={this.state.loading}
              imageSrc={loaderColors1}
              overlayBackground="rgba(0,0,0,0.5)"
              label="Loading chapter topics"
            />
            <Header
              userVO={this.state.userVO}
              bookVO={this.state.bookVO}
              pageName="study"
            ></Header>
            <StudyCenterHeader userVO={this.state.userVO} />
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="row greyDiv">
                <div className="col-lg-8 col-md-6 col-sm-12 headingDiv studyMarginHead">
                  <span className="insightProperty">
                    {this.state.bookTitle}
                  </span>
                  <br />
                  <span className="insightHeading">
                    {this.state.chapterNavTitle}
                  </span>
                  <div
                    className="studyLink cusorPointer"
                    onClick={this.navigateToDashBoard}
                  >
                    <span
                      tabIndex="0"
                      onKeyDown={(e) => this.handleBackToStudyCenter(e)}
                    >
                      Back to Study Center
                    </span>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-6 col-sm-12 viewhead"
                  style={{
                    display: "inline-flex",
                    justifyContent: "center",
                    margin: "auto",
                  }}
                >
                  <span className="insightProperty">View results for:</span>
                  <a
                    className="fontAwesomeBlackColor"
                    href="javascript:void(0)"
                    onClick={this.handleClick}
                  >
                    <div
                      className={
                        this.state.isOpen
                          ? "dropdown active IphoneMargin"
                          : "dropdown IphoneMargin"
                      }
                      style={{
                        marginLeft: "15px",
                        width: "210px",
                        background: "#FFFFFF 0% 0% no-repeat padding-box",
                        border: "1px solid #000000",
                        zIndex: "999",
                      }}
                    >
                      <div className="dropdown__text">
                        <div className="textOverflowClass">
                          {" "}
                          {!this.state.haveText
                            ? "Select Class"
                            : this.state.haveText}
                        </div>
                      </div>
                      {itemList(chapters)}
                    </div>
                  </a>
                </div>
              </div>
              <div className="row">
                <div className="studyDiv col-md-8 col-lg-8">
                  <div className="studyDivDhonutHideBlock col-md-12 col-lg-12 no-padding">
                    {this.state.learningObjectiveProgressVOList !== null
                      ? this.state.learningObjectiveProgressVOList.map(
                          (learningObjective, index) =>
                            learningObjective.learningObjName !== undefined ? (
                              <div>
                                {parseInt(
                                  learningObjective.totalNumberOfQuestionInLearningObjective,
                                ) > 0 ? (
                                  <>
                                    <div>
                                      <span
                                        className="studyHeading"
                                        id="secondMenu"
                                        index={index}
                                        style={{ cursor: "pointer" }}
                                        onClick={this.expandClickOnNameEvent}
                                        tabIndex="0"
                                        onKeyDown={(e) =>
                                          this.handleExpandStudyHeading(e)
                                        }
                                      >
                                        {learningObjective.learningObjName}
                                      </span>
                                      <i
                                        style={{
                                          float: "right",
                                          cursor: "pointer",
                                        }}
                                        className="fa fa-plus"
                                        id={"secondMenuITag" + index}
                                        index={index}
                                        onClick={this.expandClickEvent}
                                        role="button"
                                        aria-pressed="false"
                                        aria-label="Expand Topic"
                                      ></i>
                                    </div>
                                    <span className="insightProperty">
                                      {learningObjective.learningObjDescription}
                                    </span>
                                    <br />
                                    <span className="insightProperty">
                                      {
                                        learningObjective.totalNumberOfQuestionInLearningObjective
                                      }
                                      {parseInt(
                                        learningObjective.totalNumberOfQuestionInLearningObjective,
                                      ) > 1
                                        ? " questions"
                                        : " question"}
                                    </span>
                                    <br />
                                    {parseInt(
                                      learningObjective.totalNumberOfQuestionInLearningObjective,
                                    ) > 0 ? (
                                      <div>
                                        <div className="multicolor-bar">
                                          <br />
                                          <ProgressBar>
                                            <ProgressBar
                                              className="progress-greenColor"
                                              aria-label={`${learningObjective.learningObjName}: correctly answered questions percentage`}
                                              now={decimalFormat(
                                                (parseInt(
                                                  learningObjective.totalCorrectAnswerInLearningObjective,
                                                ) /
                                                  (parseInt(
                                                    learningObjective.totalNumberOfQuestionInLearningObjective,
                                                  ) *
                                                    (this.state
                                                      .numberOfEnrolledStudent >
                                                    0
                                                      ? this.state
                                                          .numberOfEnrolledStudent
                                                      : 1))) *
                                                  100,
                                              )}
                                              key={1}
                                            />
                                            <ProgressBar
                                              className="progress-redColor"
                                              aria-label={`${learningObjective.learningObjName}: incorrectly answered questions percentage`}
                                              now={decimalFormat(
                                                (parseInt(
                                                  learningObjective.totalWrongAnswerInLearningObjective,
                                                ) /
                                                  (parseInt(
                                                    learningObjective.totalNumberOfQuestionInLearningObjective,
                                                  ) *
                                                    (this.state
                                                      .numberOfEnrolledStudent >
                                                    0
                                                      ? this.state
                                                          .numberOfEnrolledStudent
                                                      : 1))) *
                                                  100,
                                              )}
                                              key={2}
                                            />
                                            <ProgressBar
                                              className="progress-blueColor"
                                              aria-label={`${learningObjective.learningObjName}: practice needed questions percentage`}
                                              now={decimalFormat(
                                                (parseInt(
                                                  learningObjective.totalPartialCorrectInLearningObjective,
                                                ) /
                                                  (parseInt(
                                                    learningObjective.totalNumberOfQuestionInLearningObjective,
                                                  ) *
                                                    (this.state
                                                      .numberOfEnrolledStudent >
                                                    0
                                                      ? this.state
                                                          .numberOfEnrolledStudent
                                                      : 1))) *
                                                  100,
                                              )}
                                              key={3}
                                            />
                                            <ProgressBar
                                              className="progress-greyColor"
                                              aria-label={`${learningObjective.learningObjName}: unanswered questions percentage`}
                                              now={
                                                100 -
                                                (decimalFormat(
                                                  (parseInt(
                                                    learningObjective.totalCorrectAnswerInLearningObjective,
                                                  ) /
                                                    (parseInt(
                                                      learningObjective.totalNumberOfQuestionInLearningObjective,
                                                    ) *
                                                      (this.state
                                                        .numberOfEnrolledStudent >
                                                      0
                                                        ? this.state
                                                            .numberOfEnrolledStudent
                                                        : 1))) *
                                                    100,
                                                ) +
                                                  decimalFormat(
                                                    (parseInt(
                                                      learningObjective.totalWrongAnswerInLearningObjective,
                                                    ) /
                                                      (parseInt(
                                                        learningObjective.totalNumberOfQuestionInLearningObjective,
                                                      ) *
                                                        (this.state
                                                          .numberOfEnrolledStudent >
                                                        0
                                                          ? this.state
                                                              .numberOfEnrolledStudent
                                                          : 1))) *
                                                      100,
                                                  ) +
                                                  decimalFormat(
                                                    (parseInt(
                                                      learningObjective.totalPartialCorrectInLearningObjective,
                                                    ) /
                                                      (parseInt(
                                                        learningObjective.totalNumberOfQuestionInLearningObjective,
                                                      ) *
                                                        (this.state
                                                          .numberOfEnrolledStudent >
                                                        0
                                                          ? this.state
                                                              .numberOfEnrolledStudent
                                                          : 1))) *
                                                      100,
                                                  ))
                                              }
                                              key={4}
                                            />
                                          </ProgressBar>
                                        </div>
                                        <span className="insightProperty">
                                          <div className="value">
                                            <span>
                                              {" "}
                                              {decimalFormat(
                                                (parseInt(
                                                  learningObjective.totalCorrectAnswerInLearningObjective,
                                                ) /
                                                  (parseInt(
                                                    learningObjective.totalNumberOfQuestionInLearningObjective,
                                                  ) *
                                                    (this.state
                                                      .numberOfEnrolledStudent >
                                                    0
                                                      ? this.state
                                                          .numberOfEnrolledStudent
                                                      : 1))) *
                                                  100,
                                              )}
                                              %&nbsp;Correct
                                            </span>
                                            <span className="pipeLine_rt">
                                              &nbsp;|&nbsp;
                                            </span>
                                            <span>
                                              {decimalFormat(
                                                (parseInt(
                                                  learningObjective.totalWrongAnswerInLearningObjective,
                                                ) /
                                                  (parseInt(
                                                    learningObjective.totalNumberOfQuestionInLearningObjective,
                                                  ) *
                                                    (this.state
                                                      .numberOfEnrolledStudent >
                                                    0
                                                      ? this.state
                                                          .numberOfEnrolledStudent
                                                      : 1))) *
                                                  100,
                                              )}
                                              %&nbsp;Incorrect
                                            </span>
                                            <span className="pipeLine_rt">
                                              &nbsp;|&nbsp;
                                            </span>
                                            <span>
                                              {decimalFormat(
                                                (parseInt(
                                                  learningObjective.totalPartialCorrectInLearningObjective,
                                                ) /
                                                  (parseInt(
                                                    learningObjective.totalNumberOfQuestionInLearningObjective,
                                                  ) *
                                                    (this.state
                                                      .numberOfEnrolledStudent >
                                                    0
                                                      ? this.state
                                                          .numberOfEnrolledStudent
                                                      : 1))) *
                                                  100,
                                              )}
                                              %&nbsp;Needs practice
                                            </span>
                                            <span className="pipeLine_rt">
                                              &nbsp;|&nbsp;
                                            </span>
                                            <span>
                                              {decimalFormat(
                                                (parseInt(
                                                  learningObjective.totalUnAnsweredInLearningObjective,
                                                ) /
                                                  (parseInt(
                                                    learningObjective.totalNumberOfQuestionInLearningObjective,
                                                  ) *
                                                    (this.state
                                                      .numberOfEnrolledStudent >
                                                    0
                                                      ? this.state
                                                          .numberOfEnrolledStudent
                                                      : 1))) *
                                                  100,
                                              )}
                                              %&nbsp;Unanswered
                                            </span>
                                          </div>
                                        </span>
                                      </div>
                                    ) : null}
                                    <hr id={"hiddenExpand" + index} />

                                    <div
                                      id={"secondMenuDiv" + index}
                                      index={index}
                                      className="hiddenDiv"
                                    >
                                      <br />
                                      {learningObjective.learningObjectiveExplainerResponseList.filter(
                                        (x) => x.totalQuestions > 0,
                                      ).length > 0 ? (
                                        <div className="explanatorySection">
                                          <span className="insightHeading">
                                            Learn
                                          </span>
                                          <br /> <br />
                                          {learningObjective.learningObjectiveExplainerResponseList
                                            .filter((x) => x.totalQuestions > 0)
                                            .map((learn, index) => (
                                              <span>
                                                <div className="d-flex">
                                                  <div
                                                    data-testid={`learn_icon_${learningObjective.learningObjId}`}
                                                    aria-hidden="true"
                                                    className={
                                                      learn.explainerType ===
                                                      "video"
                                                        ? "videoIcon"
                                                        : learn.explainerType ===
                                                            "audio"
                                                          ? "audioIcon"
                                                          : "studyFileIcon"
                                                    }
                                                    explainerType={
                                                      learn.explainerType
                                                    }
                                                    learningObjectiveId={
                                                      learningObjective.learningObjId
                                                    }
                                                    onClick={(e) =>
                                                      this.openWatchVideoPage(e)
                                                    }
                                                  >
                                                    <i
                                                      className={
                                                        learn.explainerType ===
                                                        "video"
                                                          ? "fas fa-video"
                                                          : learn.explainerType ===
                                                              "audio"
                                                            ? "audioIcon"
                                                            : "fas fa-file-alt"
                                                      }
                                                      aria-hidden="true"
                                                      style={{
                                                        fontSize: "18px",
                                                        color: "#007AC3",
                                                      }}
                                                    ></i>
                                                  </div>
                                                  &nbsp;
                                                  <div
                                                    data-testid={`learn_${learningObjective.learningObjId}`}
                                                    className="insightProperty my-auto"
                                                    explainerType={
                                                      learn.explainerType
                                                    }
                                                    learningObjectiveId={
                                                      learningObjective.learningObjId
                                                    }
                                                    onClick={(e) =>
                                                      this.openWatchVideoPage(e)
                                                    }
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    tabIndex="0"
                                                    onKeyDown={(e) =>
                                                      this.handleWatchVideoPage(
                                                        e,
                                                      )
                                                    }
                                                  >
                                                    {learn.explainerType ===
                                                    "video"
                                                      ? "Watch a video"
                                                      : learn.explainerType ===
                                                          "audio"
                                                        ? "Hear an Audio"
                                                        : "Read an explanation"}
                                                  </div>
                                                </div>
                                                <br /> <br />
                                              </span>
                                            ))}
                                        </div>
                                      ) : null}
                                      {learningObjective.learningObjectiveResponseList.filter(
                                        (x) => x.totalQuestions > 0,
                                      ).length > 0 ? (
                                        <div className="practiceSection">
                                          <span className="insightHeading">
                                            Practice
                                          </span>
                                          <br /> <br />
                                          <div className="col-12 row p-0">
                                            {learningObjective.learningObjectiveResponseList
                                              .filter(
                                                (x) => x.totalQuestions > 0,
                                              )
                                              .map((practice, index) => (
                                                <div
                                                  className="ml-2"
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <div
                                                    data-testid={`practice_${learningObjective.learningObjId}`}
                                                    learningObjectiveId={
                                                      learningObjective.learningObjId
                                                    }
                                                    questionType={
                                                      practice.questionType
                                                    }
                                                    onClick={
                                                      this.reviewQuestion
                                                    }
                                                    className="col-lg-12"
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <span
                                                      data-testid={`practice_key_${learningObjective.learningObjId}`}
                                                      learningObjectiveId={
                                                        learningObjective.learningObjId
                                                      }
                                                      questionTypeTitle={
                                                        practice.questionType
                                                      }
                                                      questionType={
                                                        practice.questionType
                                                      }
                                                      className="insightProperty"
                                                      tabIndex="0"
                                                      onKeyDown={(e) =>
                                                        this.handlePracticeQuestion(
                                                          e,
                                                        )
                                                      }
                                                    >
                                                      {practice.questionType ===
                                                      "multichoice"
                                                        ? "Multiple Choice"
                                                        : practice.questionType ===
                                                            "flashcard"
                                                          ? "Flash Cards"
                                                          : practice.questionType ===
                                                              "hypothetical"
                                                            ? "Short Answer"
                                                            : practice.questionType ===
                                                                "essay"
                                                              ? "Essay"
                                                              : practice.questionType ===
                                                                  "issuespotting"
                                                                ? "Issue Spotting"
                                                                : ""}{" "}
                                                      <br />
                                                      {
                                                        practice.totalQuestions
                                                      }{" "}
                                                      {parseInt(
                                                        practice.totalQuestions,
                                                      ) > 1
                                                        ? " questions"
                                                        : " question"}
                                                    </span>
                                                    <div>Student Average</div>
                                                    <div
                                                      learningObjectiveId={
                                                        learningObjective.learningObjId
                                                      }
                                                      aria-hidden="true"
                                                      questionType={
                                                        practice.questionType
                                                      }
                                                      style={{
                                                        width: "5rem",
                                                        margin: "auto",
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      {studyPieChart(
                                                        practice,
                                                        learningObjective.learningObjId,
                                                      )}
                                                    </div>
                                                    <span
                                                      learningObjectiveId={
                                                        learningObjective.learningObjId
                                                      }
                                                      questionType={
                                                        practice.questionType
                                                      }
                                                      className="insightProperty"
                                                    >
                                                      {chartStats(practice)}{" "}
                                                      <br></br>
                                                    </span>
                                                  </div>
                                                  <button
                                                    className="viewTopicButton"
                                                    style={{
                                                      marginTop: "10px",
                                                    }}
                                                    learningObjectiveId={
                                                      learningObjective.learningObjId
                                                    }
                                                    questionType={
                                                      practice.questionType
                                                    }
                                                    onClick={
                                                      this.navigateToAssessment
                                                    }
                                                  >
                                                    Student Preview
                                                  </button>
                                                </div>
                                              ))}
                                          </div>
                                          <br />
                                        </div>
                                      ) : null}
                                      <hr />
                                    </div>
                                    <br />
                                  </>
                                ) : null}
                              </div>
                            ) : this.state.serviceCompletion ? (
                              "No study materials available for this chapter. Select another chapter from the Contents menu above."
                            ) : (
                              ""
                            ),
                        )
                      : ""}
                  </div>
                  <br />
                  <div>
                    <span className="insightHeading">
                      About the Connected eBook Study Center
                    </span>
                    <br /> <br />
                    <span className="insightProperty">
                      The content in the Study Center is selected and maintained
                      exclusively by Aspen Publishing and a team of professor
                      reviewers and editors, not by the authors of your book.
                      These materials typically come from one or more of Aspen
                      Publishing's top study aids, including Examples &
                      Explanations, Glannon Guides, Emanuel Law Outlines, and
                      Emanuel Law in a Flash, or may be created with assistance
                      from AI tools. Study material sources and activity types
                      vary depending on availability for any given chapter,
                      topic, or course.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        <Footer />
      </React.Fragment>
    );
  }
}
export default withAuth(withRouter(StudyCenterProfessorPage));
